import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { JOB_POSTING_STATUS } from '../../../utils/constants';
import { JobPostingContext } from '../../../contexts/JobPostingContext';

const CompleteJobPostingDialog = ({ jobPostingPage }) => {
  const {
    jobPostingStore: {
      pendingCompletionJobPostingId,
      toggleMarkCompleteModal,
      updateJobPostingStatus: updateJobPostingStatusStore
    }
  } = useStore();

  const {
    updateJobPostingStatus
  } = useContext(JobPostingContext);

  return (
    <ConfirmDialog
      headerText="Mark Job Posting Complete"
      open={!!pendingCompletionJobPostingId}
      onConfirm={() => {
        if (jobPostingPage) {
          updateJobPostingStatus(pendingCompletionJobPostingId, JOB_POSTING_STATUS.COMPLETED, jobPostingPage, toggleMarkCompleteModal);
        } else {
          updateJobPostingStatusStore(pendingCompletionJobPostingId, JOB_POSTING_STATUS.COMPLETED, false, toggleMarkCompleteModal);
        }
      }}
      onClose={() => {
        toggleMarkCompleteModal();
      }}
      confirmTestId="confirm-complete-job-posting"
      confirmText="Mark Posting Complete"
      cancelText="Cancel"
    >
      Congratulations on filling your job!<br /> When you mark the posting as complete, you close the job
      so no other candidates can apply. Candidates will no longer be able to see the job posting or
      apply.<br /> You will still be able to see all candidates who applied, your recommended candidates
      and your job posting details.
    </ConfirmDialog>
  );
};

export default observer(CompleteJobPostingDialog);
